import React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SignaturePreviewDialogProps {
  open: boolean;
  onClose: () => void;
  previewURL: string;
}

const SignaturePreviewDialog: React.FC<SignaturePreviewDialogProps> = ({ open, onClose, previewURL }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
  >
    <DialogContent sx={{ p: 0, position: 'relative' }}>
      <IconButton
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          top: theme.spacing(0.5),
          right: theme.spacing(0.5),
          zIndex: 1,
        })}
        size="small"
      >
        <CloseIcon />
      </IconButton>
      <Box
        component="img"
        src={previewURL}
        sx={{ width: '100%', display: 'block' }}
      />
    </DialogContent>
  </Dialog>
);

export default SignaturePreviewDialog;
